import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dea43ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-info-panel" }
const _hoisted_2 = { class: "user-info-preview" }
const _hoisted_3 = { class: "selection-type" }
const _hoisted_4 = {
  key: 0,
  class: "fal fa-user fa-2x"
}
const _hoisted_5 = { class: "menuButton-icon" }

export function render(_ctx, _cache) {
  const _component_ApplicationMenu = _resolveComponent("ApplicationMenu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.infoTextRow0), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.infoTextRow1), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.selectionTypeClassName == 'investigator')
        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => (_ctx.onMenuClicked && _ctx.onMenuClicked(...args)), ["prevent","stop"])),
      ref: "menuButton",
      class: "menuButton"
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("i", {
          class: _normalizeClass(['far', 'fa-3x', _ctx.menuIcon, 'icon'])
        }, null, 2)
      ])
    ], 512),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.showMenu)
          ? (_openBlock(), _createBlock(_component_ApplicationMenu, {
              key: 0,
              ref: "dropDownMenu",
              show: _ctx.showMenu
            }, null, 8, ["show"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}